// src/heading/heading-context.ts
import { createContext } from "react";
var HeadingContext = createContext(0);

export {
  HeadingContext
};
